import { lazyLoadContentComponent, loadBundle } from '../../../services/LazyLoadComponent';

export default lazyLoadContentComponent(() =>
    import(/* webpackChunkName: 'RichTextAreaTestPage' */ '.').then(loadBundle)
);
